import React from 'react';
import { Container, Row, Col, CardBody, Card } from 'reactstrap';
import AlphaNumericInput from '../../common/AlphaNumericInput';

const AlphaNumericComponent = () => {
    return (
        <div className='page-content components'>
            <Container>
                <Card>
                    <CardBody>
                        <h2 className="mb-4">Alphanumeric Input Showcase</h2>

                        {/* First Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <AlphaNumericInput
                                    name="primaryString"
                                    id="primaryStringInput"
                                    required={true}
                                    layout="below"
                                    placeholder="Enter alphanumeric string"
                                    showHelp={true}
                                    helpText="Please enter a valid alphanumeric string."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<AlphaNumericInput
    name="primaryString"
    id="primaryStringInput"
    required={true}
    layout="below"
    placeholder="Enter alphanumeric string"
    showHelp={true}
    helpText="Please enter a valid alphanumeric string."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Second Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <AlphaNumericInput
                                    name="businessString"
                                    id="businessStringInput"
                                    required={true}
                                    layout="below"
                                    placeholder="Enter business string"
                                    showHelp={true}
                                    helpText="This is required for business input."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<AlphaNumericInput
    name="businessString"
    id="businessStringInput"
    required={true}
    layout="below"
    placeholder="Enter business string"
    showHelp={true}
    helpText="This is required for business input."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Third Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <AlphaNumericInput
                                    name="optionalString"
                                    id="optionalStringInput"
                                    required={false}
                                    layout="below"
                                    placeholder="Enter optional string"
                                    showHelp={true}
                                    helpText="This field is optional."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<AlphaNumericInput
    name="optionalString"
    id="optionalStringInput"
    required={false}
    layout="below"
    placeholder="Enter optional string"
    showHelp={true}
    helpText="This field is optional."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>

                        {/* Fourth Row */}
                        <Row className="mb-4">
                            <Col lg={6}>
                                <AlphaNumericInput
                                    name="secondaryString"
                                    id="secondaryStringInput"
                                    required={true}
                                    layout="below"
                                    placeholder="Enter secondary string"
                                    showHelp={true}
                                    helpText="This is required for secondary access."
                                />
                            </Col>
                            <Col lg={6}>
                                <div className="border p-3 rounded" style={{ backgroundColor: '#f8f9fa' }}>
                                    <pre>
                                        {`
<AlphaNumericInput
    name="secondaryString"
    id="secondaryStringInput"
    required={true}
    layout="below"
    placeholder="Enter secondary string"
    showHelp={true}
    helpText="This is required for secondary access."
/>
                                        `}
                                    </pre>
                                </div>
                            </Col>
                        </Row>
                    </CardBody>
                </Card>
            </Container>
        </div>
    );
};

export default AlphaNumericComponent;
